import React,{useEffect} from 'react'
import "./pending.css";

const SuccessEvinaPage = () => {

    const url = new URL(window.location.href);
  const extId = url.searchParams.get("ext_ref")


    useEffect(()=>{
        window.location.replace(`https://sdp-p-vas-payment.telkom.co.za/349?ext_ref=${extId}`)
    },[])


  return (
    <div>
      <div id="notfound">
                <div className="notfound">
                    <div className="notfound-404">
                        <h1>Authentic</h1>
                        <h2>Success</h2>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default SuccessEvinaPage
